import React, { useMemo } from 'react';
import * as Styled from './styled';
import PropTypes from 'prop-types';
import { formatPageItemsRange } from '../../utils/common';

const Pagination = ({
  total,
  itemsPerPage,
  currentPage,
  onPageChange,
  showPageNo
}) => {
  const calculatePageNumbers = () => {
    const pageNumbers = [];
    for (var i = 1; i <= Math.ceil(total / itemsPerPage); i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const pageNumbers = useMemo(
    () => calculatePageNumbers(),
    [total, itemsPerPage]
  );

  const fromCount = useMemo(
    () => (currentPage - 1) * itemsPerPage + 1,
    [currentPage, itemsPerPage]
  );

  const toCount = useMemo(() => {
    const currentPageCount = currentPage * itemsPerPage;

    return currentPageCount > total ? total : currentPageCount;
  }, [currentPage, total, itemsPerPage]);

  return (
    <Styled.PaginationContainer>
      <Styled.PaginationLbl>
        {formatPageItemsRange({
          total,
          fromCount,
          toCount,
          itemsLabel: 'Investigator'
        })}
      </Styled.PaginationLbl>
      {showPageNo ? (
        <>
          <Styled.PaginationPrevArrow
            isDisabled={currentPage == 1 ? true : false}
            disabled={currentPage == 1 ? true : false}
            onClick={() => onPageChange(currentPage - 1)}>
            {'<'}
          </Styled.PaginationPrevArrow>
          {pageNumbers &&
            pageNumbers.map((number) => (
              <Styled.PaginationButton
                key={number}
                isActive={currentPage == number ? true : false}
                onClick={() => onPageChange(number)}>
                {number}
              </Styled.PaginationButton>
            ))}
          <Styled.PaginationNextArrow
            isDisabled={
              currentPage == pageNumbers[pageNumbers.length - 1] ? true : false
            }
            disabled={
              currentPage == pageNumbers[pageNumbers.length - 1] ? true : false
            }
            onClick={() => onPageChange(currentPage + 1)}>
            {'>'}
          </Styled.PaginationNextArrow>
        </>
      ) : (
        ''
      )}
    </Styled.PaginationContainer>
  );
};

Pagination.propTypes = {
  total: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func,
  showPageNo: PropTypes.bool.isRequired
};

export default Pagination;
